import { Button } from 'reactstrap'
import { IProduct } from '../products'

export const Product = (props: ProductPropTypes) => {
    const p = props.p

    return (
        <div className="product-wrapper">
            <div className="img-wrapper" style={{backgroundImage: `url("./img/${props.p.img}")`}} />
            <div className="description text-center">
                {p.name}
                <div className="price">
                    $ {p.price.toLocaleString()}
                </div>
                <Button onClick={() => props.openModal(p)}>Regalar</Button>
            </div>
        </div>
    )
}

type ProductPropTypes = {
    p: IProduct
    openModal: (p :IProduct) => void;
}